import {HYDRATE} from 'next-redux-wrapper';
import {ALERT_CONSTANTS} from '../actions/AlertActions';

const ALERT_INITIATE_STATE = {
    title: 'خطا',
    content: null,
    show: false,
    type: 'primary',
    func: null,
    modalOnCancel: null,
    extraButton: {
        show: false,
        text: null,
        type: null,
        func: null,
    }
};

export default function(state = ALERT_INITIATE_STATE, action) {
    switch (action.type) {

        case HYDRATE:
            return {...state, ...action.payload.Alert};

        case ALERT_CONSTANTS.SET:
            return {
                ...state,
                ...action.payload,
                show: true,
            };

        case ALERT_CONSTANTS.RESET:
            return {...ALERT_INITIATE_STATE};

        default:
            return state;
    }
}